export default {
  // Page metadata
  'meta.title': 'সেবার শর্তাবলী - timer.today',
  'meta.description': 'timer.today অনলাইন টাইমিং সরঞ্জাম প্ল্যাটফর্মের সেবার শর্তাবলী এবং ব্যবহার চুক্তি। আমাদের সেবা নিয়ম, ব্যবহারকারীর অধিকার এবং দায়িত্ব সম্পর্কে জানুন।',

  // Page header
  'page.title': 'সেবার শর্তাবলী',
  'page.lastUpdated': 'সর্বশেষ আপডেট: {{date}}',
  'page.intro': 'timer.today-তে স্বাগতম। এই শর্তাবলী timer.today ওয়েবসাইট ব্যবহারের নিয়ম ও প্রবিধান বর্ণনা করে, যা timer.today-এ অবস্থিত।',

  // Section 1
  'section1.title': '১. শর্তাবলী গ্রহণ',
  'section1.content': 'এই ওয়েবসাইট অ্যাক্সেস এবং ব্যবহার করে, আপনি এই চুক্তির শর্তাবলী দ্বারা আবদ্ধ হতে স্বীকার করেন এবং সম্মত হন। যদি আপনি উপরোক্ত মেনে চলতে সম্মত না হন, তাহলে অনুগ্রহ করে এই পরিষেবা ব্যবহার করবেন না।',

  // Section 2
  'section2.title': '২. সেবা বিবরণ',
  'section2.intro': 'timer.today বিনামূল্যে অনলাইন টাইমিং সরঞ্জাম প্রদান করে যার মধ্যে রয়েছে:',
  'section2.timer': 'কাউন্টডাউন টাইমার - উৎপাদনশীলতা, রান্না এবং সময় ব্যবস্থাপনার জন্য কাস্টমাইজযোগ্য টাইমার',
  'section2.stopwatch': 'স্টপওয়াচ - খেলাধুলা, প্রশিক্ষণ এবং নির্ভুল সময় নির্ধারণের জন্য উচ্চ-নির্ভুলতা সময় সরঞ্জাম',
  'section2.worldclock': 'বিশ্ব ঘড়ি - বিশ্বব্যাপী সময় অঞ্চলের রিয়েল-টাইম প্রদর্শন',

  // Section 3
  'section3.title': '৩. ব্যবহার লাইসেন্স',
  'section3.intro': 'শুধুমাত্র ব্যক্তিগত, অ-বাণিজ্যিক সাময়িক দেখার জন্য timer.today অস্থায়ীভাবে ব্যবহারের অনুমতি দেওয়া হয়েছে। এটি একটি লাইসেন্স প্রদান, শিরোনাম স্থানান্তর নয়, এবং এই লাইসেন্সের অধীনে আপনি পারবেন না:',
  'section3.item1': 'উপাদান পরিবর্তন বা অনুলিপি করা',
  'section3.item2': 'যে কোনো বাণিজ্যিক উদ্দেশ্যে বা যে কোনো পাবলিক প্রদর্শনের জন্য উপাদান ব্যবহার করা',
  'section3.item3': 'ওয়েবসাইটে থাকা যে কোনো সফটওয়্যার রিভার্স ইঞ্জিনিয়ার করার চেষ্টা করা',
  'section3.item4': 'উপাদান থেকে যে কোনো কপিরাইট বা অন্যান্য মালিকানা স্বীকৃতি সরানো',

  // Section 4
  'section4.title': '৪. গোপনীয়তা এবং ডেটা',
  'section4.intro': 'timer.today আপনার গোপনীয়তা রক্ষা করতে প্রতিশ্রুতিবদ্ধ:',
  'section4.item1': 'আমরা ব্যক্তিগত তথ্য সংগ্রহ বা সংরক্ষণ করি না',
  'section4.item2': 'টাইমার সেটিংস আপনার ব্রাউজারে স্থানীয়ভাবে সংরক্ষণ করা হয়',
  'section4.item3': 'আমরা ব্যবহারকারীর আচরণ বা ব্যবহার প্যাটার্ন ট্র্যাক করি না',
  'section4.item4': 'ট্র্যাকিং উদ্দেশ্যে কোন কুকি ব্যবহার করা হয় না',

  // Section 5
  'section5.title': '৫. দাবিত্যাগ',
  'section5.content': 'timer.today-এর উপাদানগুলি \'যেমন আছে\' ভিত্তিতে প্রদান করা হয়। timer.today কোন ওয়ারেন্টি, প্রকাশ বা উহ্য, প্রদান করে না এবং এতদ্বারা ব্যবসায়যোগ্যতার উহ্য ওয়ারেন্টি বা শর্ত, একটি নির্দিষ্ট উদ্দেশ্যে উপযুক্ততা, বা মেধা সম্পত্তির অ-লঙ্ঘন বা অধিকারের অন্যান্য লঙ্ঘন সহ কিন্তু সীমাবদ্ধ নয়, সমস্ত অন্যান্য ওয়ারেন্টি অস্বীকার এবং অস্বীকার করে।',

  // Section 6
  'section6.title': '৬. সীমাবদ্ধতা',
  'section6.content': 'কোন ক্ষেত্রেই timer.today বা এর সরবরাহকারীরা timer.today-এ উপাদান ব্যবহার বা ব্যবহারে অক্ষমতার ফলে উদ্ভূত কোন ক্ষতির (ডেটা বা লাভের ক্ষতি, বা ব্যবসায় বাধার কারণে ক্ষতি সহ কিন্তু সীমাবদ্ধ নয়) জন্য দায়বদ্ধ হবে না, এমনকি যদি timer.today বা এর অনুমোদিত প্রতিনিধিকে মৌখিক বা লিখিতভাবে এই ধরনের ক্ষতির সম্ভাবনা সম্পর্কে অবহিত করা হয়ে থাকে।',

  // Section 7
  'section7.title': '৭. উপাদানের নির্ভুলতা',
  'section7.content': 'timer.today-এ প্রদর্শিত উপাদানে প্রযুক্তিগত, মুদ্রণ, বা ফটোগ্রাফিক ত্রুটি অন্তর্ভুক্ত হতে পারে। timer.today ওয়ারেন্ট করে না যে এর ওয়েবসাইটে উপাদানগুলির কোনটি নির্ভুল, সম্পূর্ণ বা বর্তমান। timer.today কোনো বিজ্ঞপ্তি ছাড়াই যেকোনো সময় এর ওয়েবসাইটে থাকা উপাদানে পরিবর্তন করতে পারে।',

  // Section 8
  'section8.title': '৮. পরিবর্তন',
  'section8.content': 'timer.today কোনো বিজ্ঞপ্তি ছাড়াই যেকোনো সময় এর ওয়েবসাইটের জন্য এই সেবার শর্তাবলী পর্যালোচনা করতে পারে। এই ওয়েবসাইট ব্যবহার করে, আপনি সেবার শর্তাবলীর তৎকালীন বর্তমান সংস্করণ দ্বারা আবদ্ধ হতে সম্মত হচ্ছেন।',

  // Section 9
  'section9.title': '৯. যোগাযোগের তথ্য',
  'section9.intro': 'যদি এই সেবার শর্তাবলী সম্পর্কে আপনার কোন প্রশ্ন থাকে, তাহলে অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন:',
  'section9.email': 'ইমেইল:',
  'section9.emailSubject': 'সেবার শর্তাবলী অনুসন্ধান - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024। সর্বস্বত্ব সংরক্ষিত।'
};
